import { combineReducers } from "redux";
import * as actionType from "../actions/actionTypes";
import lsencryption from "../services/lsencryption";
import { logError } from "../helper/auth";

const communityReducers = (state = {}, action) => {
  switch (action.type) {
    case actionType.SET_USER_DETAIL:
      return {
        ...state,
        ...action.payload,
        // dashboardSideBar: action.payload.roleComponents.dashboard_side_bar
      };
    case actionType.SET_LANGUAGE_LIST:
      return {
        ...state,
        languageList: action.payload,
      };
    case actionType.SET_SELECTED_NEARME:
      return {
        ...state,
        selectedNearme: action.payload,
      };
    case actionType.RESET_SELECTED_NEARME:
      return {
        ...state,
        selectedNearme: {},
      };
    default:
      let oCom;
      try {
        let oParam = lsencryption.get("community");
        oCom = oParam ? JSON.parse(lsencryption.get("community")) : oParam;
        oCom = oCom ? { ...oCom } : {};
      } catch {
        localStorage.clear();
        const errorObj = {
          component: "communityReducers",
          method: "default",
          error: "clearing local storage",
        };
        logError(errorObj);
      }
      return oCom ? { ...state, ...oCom } : { ...state };
  }
};

/* const changeUUID = (state, action) =>{
    let oCom = JSON.parse(localStorage.getItem('community')),uuid = '';
    if(oCom){
      uuid = oCom.community.uuid;
    }
    return action.type === 'CHANGE_UUID' ? action.payload : uuid;
} */

const updateStateofApp = (state = false, action) => {
  if (action.type === actionType.RELOAD_PAGE) {
    return action.payload;
  }
  return state;
};

const selectedLang = (state = null, action) => {
  if (action.type === actionType.SELECTED_LANGUAGE) {
    return action.payload;
  }
  return state;
};

const updateTourguide = (state = null, action) => {
  if (action.type === actionType.TOUR_GUIDE) {
    return action.payload;
  }
  return state;
};

const updateNavbar = (state = null, action) => {
  if (action.type === actionType.Feedback_Mod) {
    return action.payload;
  }
  return state;
};

const isCloningAVailable = (state = null, action) => {
  if (action.type === actionType.CLONING_FLAG) {
    let oCom = JSON.parse(lsencryption.get("community")),
      { componentList } = oCom,
      { dashboardSections } = componentList,
      oSmartSetup = dashboardSections.filter(
        (e) => e.name === "Smart Set-Up"
      )[0];
    if (oSmartSetup) {
      let aChilds = oSmartSetup.childs,
        oSetUp = aChilds.filter((e) => e.name === "Setup")[0],
        bIsAvailble = oSetUp.childs.filter((e) => e.name === "Clone Data")[0];
      if (bIsAvailble && bIsAvailble.visible && bIsAvailble.isactive) {
        return true;
      }
    }
    return false;
  }
  return state;
};

const updateFilterFlag = (state = false, action) => {
  if (action.type === actionType.SETFILTER_FLAG) {
    return action.payload;
  }
  return state;
};
// const updateFilterData = (state = null, action) => {
//   if (action.type === actionType.SETFILTER_DATA) {
//     if(state == null && action?.payload?.length) {
//       state = {"locationFilter": action.payload}
//       //return state
//     } else if(state != null && action?.payload?.length ) {
//       state["locationFilter"] = action.payload
//       //return state
//     } else if (state != null && action?.payload?.length == undefined) {
//       if(action?.payload == null) {
//         const stateStorageForLocationFilter = state['locationFilter']
//         state = null
//         //state['locationFilter'] = stateStorageForLocationFilter
//       } else {
//         const temp = action.payload
//         state = {...state, ...temp}
//       }
//       //return state
//     } else if (state != null && action?.payload == null) {
//       state = null
//       //return state
//     }else{
//       state = action.payload
//       //return state
//     }
//   }
//   return state;
// };

const updateFilterData = (state = null, action) => {
  if (action.type === actionType.SETFILTER_DATA) {
    return action.payload;
  }
  return state;
};

const downloadPdfReducer = (state = false, action) => {
  if (action.type === actionType.SETDOWNLOAD_PDF) {
    return action.payload;
  }
  if (action.type === actionType.RESETDOWNLOAD_PDF) {
    return action.payload;
  }
  return state;
};

const resetFilterReducer = (state = false, action) => {
  if (action.type === actionType.RESETFILTER_PDF) {
    return action.payload;
  }

  return state;
};

const setActiveCLLReducer = (state = { activeTab: "second" }, action) => {
  if (action.type === actionType.ACTIVE_CLL_TAB) {
    return { activeTab: action.payload };
  }
  return state;
};

const raisedCaseLocationReducer = (state = null, action) => {
  if (action.type === actionType.SET_CASE_LOCATION) {
    return action.payload;
  }
  return state;
};

const selectedServiceReducer = (state = null, action) => {
  if (action.type === actionType.SET_SELECTED_SERVICE) {
    return action.payload;
  }
  return state;
};

const demoGraphicsData = (state = null, action) => {
  if (action.type === actionType.SET_DEMOGRAPHICSDATA) {
    return action.payload;
  }
  return state;
};

const cummulativeFilterData = (state = null, action) => {
  if (action.type === actionType.SET_CUMLATIVE_FILTER) {
    return action.payload;
  }
  return state;
};

const imageUrls = (state = false, action) => {
  if (action.type === actionType.SET_URLS) {
    return action.payload;
  }
  return state;
};

const storeImgUrl = (state = false, action) => {
  if (action.type === actionType.STORE_URLS) {
    return action.payload;
  }
  return state;
};

const applySurveyFilter = (state = "", action) => {
  if (action.type === actionType.APPLY_SURVEY_FILTER) {
    return action.payload;
  }
  return state;
};

const donwloadClmPdf = (state = false, action) => {
  if (action.type === actionType.SET_DOWNLOAD_CLM_PDF) {
    return action.payload;
  }
  return state;
};

const checkAllChartLoaded = (state = false, action) => {
  if (action.type === actionType.SET_CHECK_ALL_CHART_LOAD) {
    return action.payload;
  }
  return state;
};

const surveyMedia = (state = {}, action) => {
  if (action.type === actionType.SET_SURVEY_MEDIA) {
    return action.payload;
  }
  return state;
};

const hideInboxDrawer = (state = false, action) => {
  if (action.type === actionType.SET_INBOX_DRAWER) {
    return action.payload;
  }
  return state;
};

const serviceIndicatorList = (state = [], action) => {
  if (action.type === actionType.SET_SERVICE_INDICATOR) {
    return action.payload;
  }
  return state;
};

export default combineReducers({
  communityData: communityReducers,
  appState: updateStateofApp,
  selectedLang: selectedLang,
  updateTourguide: updateTourguide,
  updateNavbar: updateNavbar,
  isCloningAVailable: isCloningAVailable,
  pageFilterFlag: updateFilterFlag,
  globalFilters: updateFilterData,
  downloadPdfReducer: downloadPdfReducer,
  resetFilterReducer: resetFilterReducer,
  activeCLLReducer: setActiveCLLReducer,
  raisedCaseLocationReducer: raisedCaseLocationReducer,
  selectedServiceReducer: selectedServiceReducer,
  demoGraphicsData: demoGraphicsData,
  cummulativeFilterData: cummulativeFilterData,
  imageUrls: imageUrls,
  storeImgUrl: storeImgUrl,
  applySurveyFilter: applySurveyFilter,
  donwloadClmPdf: donwloadClmPdf,
  checkAllChartLoaded: checkAllChartLoaded,
  surveyMedia: surveyMedia,
  hideInboxDrawer: hideInboxDrawer,
  serviceIndicatorList: serviceIndicatorList,
});
